import { DropdownOption } from "PFComponents/dropdown/dropdown";
import { useSkillsFrameworks } from "PFCore/hooks/queries/admin/skills_frameworks/use_skills_frameworks";
import { SkillsFramework } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useSkillsFrameworksListColumns } from "./table/use_skills_frameworks_table_columns";

export const useSkillsFrameworksListPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const [params, setParams] = useState<QueryParams>({ page: 1, perPage: 20, filters: {} });
  const { data: skillsFrameworks, isFetched, error } = useSkillsFrameworks(params);
  const { columns } = useSkillsFrameworksListColumns(skillsFrameworks);
  const setFilters = useCallback(
    (filters: QueryParams["filters"]) =>
      setParams((prevParams) => ({ ...prevParams, filters: { ...prevParams.filters, ...filters } })),
    [setParams]
  );
  const setPage = useCallback(
    (page: number) => setParams((prevParams) => ({ ...prevParams, page })),
    [setParams]
  );
  const [frameworkToDelete, setFrameworkToDelete] = useState<SkillsFramework | null>(null);

  const actions: DropdownOption[] = useMemo(
    () => [
      {
        id: "edit",
        displayElement: t("update"),
        item: ({ id }) => history.push(`/admin/skills_frameworks/${id}/edit`)
      },
      {
        id: "delete",
        displayElement: t("delete"),
        item: (skillFramework) => setFrameworkToDelete(skillFramework)
      }
    ],
    [history, t]
  );
  return {
    actions,
    error,
    skillsFrameworks,
    filters: params.filters,
    setFilters,
    setPage,
    columns,
    frameworkToDelete,
    setFrameworkToDelete,
    isFetched
  };
};
